<ng-container *ngFor="let item of stack; index as i">
  <ng-container *ngIf="(showStack$ | async) || i === 0">
    <li (click)="i === 0 ? showStack$.next(!expanded) : null">
      <button *ngIf="i === 0" (click)="showStack$.next(!expanded)" [class.expended]="showStack$ | async">
        <u-icon [model]="{ type: 'font', value: 'icon-chevaron-right' }"></u-icon>
      </button>
      <label *ngIf="item.functionName" class="function-name">{{ item.functionName }} &#64; &nbsp;</label>
      <label *ngIf="item.fileName" class="path">{{ item.fileName | pathShortener }} &#64; &nbsp;</label>
      <label class="position">{{ item.line }};{{ item.column }}</label>
    </li>
  </ng-container>
</ng-container>
